"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
var _layout = require("../../layout");
var _constants = require("./constants");
var _react2 = require("@emotion/react");
const getIconColor = _ref => {
  let {
    error,
    warning
  } = _ref;
  if (error) return (0, _utils.token)('color.status.critical-icon');
  if (warning) return (0, _utils.token)('color.status.warning-icon');
  return (0, _utils.token)('color.icon.secondary');
};
const InputFooterIcon = _ref2 => {
  let {
    children,
    error = false,
    warning = false,
    minHeight = 16,
    minWidth = 16,
    display = 'flex',
    alignItems = 'center',
    justifyContent = 'center',
    ...transferProps
  } = _ref2;
  return (0, _react2.jsx)(_layout.View, (0, _extends2.default)({
    height: _constants.INPUT_FOOTER_HEIGHT,
    minHeight: minHeight,
    minWidth: minWidth,
    display: display,
    alignItems: alignItems,
    justifyContent: justifyContent,
    color: getIconColor({
      error,
      warning
    })
  }, transferProps), children);
};
InputFooterIcon.displayName = 'InputFooterIcon';
InputFooterIcon.propTypes = {
  ..._layout.View.propTypes,
  error: _propTypes.default.bool,
  warning: _propTypes.default.bool
};
var _default = exports.default = InputFooterIcon;